import { Grid, Typography, Divider, Paper } from '@mui/material'

import { format } from 'date-fns'
import es from 'date-fns/locale/es'

import { formatCurrency, formatDate } from 'utils/misc'

const Approved = (props) => {
  const { information } = props

  return (
    <Grid container spacing={2} py={{ md: 3 }} px={{ xs: 2, sm: 2, md: 3 }}>
      <Grid item xs={12}>
        <Typography variant="title" color="primary">{[2, '2', 'en proceso']?.includes(information?.transaction?.transaction_status?.toLowerCase()) ? 'Pago en proceso!' : 'Pago exitoso!'}</Typography>
      </Grid>
      {/* <Grid item xs={12}>
        <Typography variant="subtitle1">Recibiras un correo con instrucciones, contrato y factura de compra.</Typography>
      </Grid> */}
      <Grid item xs={12} md={7}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Nombre</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.transaction?.fullname}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Documento</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.transaction?.doc_number}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Total</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{formatCurrency(information?.transaction?.amount)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Referencia</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.uuid}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>ID transacción</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.transaction?.uuid}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>ID pasarela</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.transaction?.ref_gateway}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>{information?.transaction?.pse_link ? 'Banco' : 'Franquicia'}</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.transaction?.pse_link ? information?.transaction?.bank_name : information?.transaction?.franchise}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Dirección IP</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.ip_address}</Typography>
          </Grid>
          <Grid item xs={12}>
            <br />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Razón social</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" textAlign="justify" fontWeight={701}>{information?.company_info?.name}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>NIT</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.company_info?.nit}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Dirección</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.company_info?.address}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary" fontWeight={601}>Ciudad</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="subtitle2" align="right" fontWeight={701}>{information?.company_info?.city}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={1} />
      <Grid item xs={12} md={4}>
        {/* <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">Resumen de compra</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ maxHeight: '50vh', overflowX: 'hidden', overflowY: 'scroll' }}>
              {information?.products?.map(product => (
                <Grid item xs={12} key={product.id}>
                  <Paper sx={{ background: '#F5F4F4', boxShadow: 'none', maxHeight: 200, overflow: 'scroll' }}>
                    <Grid container spacing={2} p={2}>
                      <Grid item xs={8}>
                        <Typography variant="h5" noWrap>{product.name}</Typography>
                        <Typography color="textSecondary" variant="caption" noWrap>sede {product.venue}</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" align="right" noWrap>$ {formatCurrency(product.total)}</Typography>
                      </Grid>
                      {product?.installments ? product?.installments.map(installment => (
                        <>
                          <Grid item xs={8}>
                            <Typography variant="subtitle2" color="textSecondary">*Cuota {formatDate(installment.init_date)} - {formatDate(installment.due_date)}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="h5" noWrap align="right">$ {formatCurrency(installment.price)}</Typography>
                          </Grid>
                        </>
                      )) : null}
                      {product?.kits ? product?.kits.map(kit => (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="h5" noWrap ml={2}>{kit.name}</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Subtotal</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="h5" noWrap align="right">$ {formatCurrency(kit.price)}</Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Descuentos</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="h5" color="primary" noWrap align="right">$ {formatCurrency(kit.discount)}</Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <Typography variant="subtitle2" color="textSecondary" noWrap ml={2}>Total</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="h5" noWrap align="right">$ {formatCurrency(kit.total)}</Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </>
                      )) : null}
                      {product?.init_date && product?.due_date ? (
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" color="textSecondary">*Cuota {formatDate(product.init_date)} - {formatDate(product.due_date)}</Typography>
                        </Grid>
                      ) : null}
                      {product?.expired_date ? (
                        <Grid item xs={12}>
                          <Typography variant="caption" display="block" color="textSecondary">Tu plan vence el {formatDate(product.expired_date)}</Typography>
                        </Grid>
                      ) : null}
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} container justifyContent="space-between">
            <Typography>Subtotal</Typography>
            <Typography variant="h5">$ {formatCurrency(information?.subtotal)}</Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="space-between">
            <Typography>Descuentos</Typography>
            <Typography variant="h5" color="primary">$ {formatCurrency(information?.discounts)}</Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="space-between">
            <Typography>Total</Typography>
            <Typography variant="h6">$ {formatCurrency(information?.total)}</Typography>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
  )
}

export default Approved
